import { FC } from 'react';
import { RadabankOnboardingContent } from 'components/RadabankCard';
import { ArrowBackButton, CustomButton } from 'components/shared';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { useGoBackRadabank } from 'utils/hooks';
import { FirebaseAnalytics } from 'utils/services';

export const RadabankAuthInfoSignDocumentsSubmissionPage: FC = () => {
	const handleClickBack = useGoBackRadabank();

	const handleGoBack = () => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.RADABANK.DOCUMENTS_SIGNING,
			FIREBASE_EVENT_ANALYTICS_BUTTON.GO_BACK
		);
		handleClickBack();
	};

	return (
		<div className="host-card-page-color-primary">
			<ArrowBackButton onClick={handleGoBack} />
			<RadabankOnboardingContent
				title="Підписання документів"
				description={['Ми перевіряємо отримані документи.', 'Ви отримаєте повідомлення, коли все буде готово']}
			/>
			<CustomButton label="Зрозуміло" color="secondary" onClick={handleClickBack} />
		</div>
	);
};
